import * as React from 'react';
import classNames from 'classnames';

export type ContextualLabel = 'active' | 'danger' | 'info' | 'success' | 'warning';

export type TableProps = React.HTMLProps<HTMLTableElement> & {
    bordered?: boolean;
    children?: React.ReactNode;
    condensed?: boolean;
    hover?: boolean;
    striped?: boolean;
};

export type TableBodyProps = React.HTMLProps<HTMLTableSectionElement> & Record<string, unknown>;

export type TableHeaderProps = Record<string, unknown> & TableRowProps;

export type TableRowProps = React.HTMLProps<HTMLTableRowElement> & {
    theme?: ContextualLabel;
};

export type TableCellProps = React.HTMLProps<HTMLTableCellElement> & {
    theme?: ContextualLabel;
};

export type TableHeaderCellProps = React.HTMLProps<HTMLTableHeaderCellElement> & {
    theme?: ContextualLabel;
};

export const Table: React.FC<TableProps> = ({ bordered, children, className, condensed, hover, striped, ...rest }) => {
    const classNameObj = classNames('table', {
        className,
        'table-bordered': bordered,
        'table-condensed': condensed,
        'table-hover': hover,
        'table-striped': striped,
    });
    return (
        <table {...rest} className={classNameObj}>
            {children}
        </table>
    );
};

export const TableBody: React.FC<TableBodyProps> = props => <tbody {...props}>{props.children}</tbody>;

export const TableHeader: React.FC<TableHeaderProps> = props => (
    <thead>
        <TableRow {...props}>{props.children}</TableRow>
    </thead>
);

export const TableRow: React.FC<TableRowProps> = ({ className, ...props }) => (
    <tr {...props} className={classNames(className, props.theme)}>
        {props.children}
    </tr>
);

export const TableCell: React.FC<TableCellProps> = ({ className, ...props }) => (
    <td {...props} className={classNames(className, props.theme)}>
        {props.children}
    </td>
);

export const TableHeaderCell: React.FC<TableHeaderCellProps> = ({ className, ...props }) => (
    <th {...props} className={classNames(className, props.theme)}>
        {props.children}
    </th>
);
